import moment from 'moment-timezone';

export const getTimezoneDate = (date, toAdd = false) => {
  if (!date) return;
  const dateConfig = {
    month: 'long',
    day: 'numeric',
  };
  const zoneIdentifier = moment.tz.guess();
  const timezoneDate = moment.tz(date, zoneIdentifier);
  const finalDate = new Date(timezoneDate);

  return {
    date: finalDate.toLocaleDateString('es-MX', dateConfig),
    day: finalDate.toLocaleDateString('es-MX', {
      weekday: 'long',
    }),
    hour: toAdd
      ? moment(timezoneDate)
          .add(2, 'h')
          .format('HH:mm')
      : timezoneDate.format('HH:mm'),
  };
};

export const isTeamDefined = team => {
  if (Object.keys(team?.images).length === 0) {
    return false;
  }
  return true;
};

export const translate = (key, translations) =>
  typeof translations?.[key] === 'string' ? translations?.[key] : '';

//algoritmo para ordenar de A a la Z arreglos de objetos
export function compare(a, b) {
  if (a.names.full < b.names.full) {
    return -1;
  }
  if (a.names.full > b.names.full) {
    return 1;
  }
  return 0;
}
//selecciones.sort(compare)

export const showPlaceHolderorImg = (img, placeholder) => {
  if (!img) {
    return { placeholder, classHolder: 'placeholder' };
  }
  return img;
};
